export default "__VITE_ASSET__AXMpABkX__"